import { FormattedMessage, useIntl } from "react-intl";
import { Link } from "react-router";
import { buttonClasses } from "@/components/design/button-classes";
import { ListingReference } from "@/pages/share/listings/ListingReference";
import type { UseMatchEditorResult } from "./use-match-editor";

export function MatchConnections({ editor }: { editor: Pick<UseMatchEditorResult, "projects" | "listings" | "sharedItem"> }) {
  const intl = useIntl();
  const objects = [
    ...(editor.projects ?? []).map((project) => ({
      nameId: `match-project-link-${project.id}`,
      key: `project-${project.id}`, to: `/project/${project.id}`, kind: "project",
      name: project.name || intl.formatMessage({ id: "match.workflow.unnamedProject" }), reference: null,
    })),
    ...(editor.listings ?? []).map((listing) => ({
      nameId: undefined,
      key: `listing-${listing.id}`, to: `/share/listings/${listing.id}`, kind: "listing",
      name: listing.name || intl.formatMessage({ id: "match.listing.unnamed" }), reference: listing.reference,
    })),
    ...(editor.sharedItem ? [{
      nameId: undefined,
      key: `share-${editor.sharedItem.id}`, to: `/share/discover/${editor.sharedItem.id}`, kind: "share",
      name: editor.sharedItem.name || intl.formatMessage({ id: "match.connections.share" }), reference: null,
    }] : []),
  ];
  if (objects.length === 0) return null;
  return (
    <nav className="mt-3 flex flex-wrap items-center gap-2" aria-label={intl.formatMessage({ id: "match.connections.title" })}>
      <span className="smycles-field-label"><FormattedMessage id="match.connections.title" /></span>
      {objects.map((object) => (
        <Link key={object.key} to={object.to} className={buttonClasses({ variant: "secondary", size: "compact", className: "gap-2" })}>
          <span><FormattedMessage id={`match.connections.${object.kind}`} /></span>{" "}
          <span id={object.nameId}>{object.name}</span>{" "}
          {object.reference ? <ListingReference reference={object.reference} /> : null}
          <span aria-hidden="true">↗</span>
        </Link>
      ))}
    </nav>
  );
}
